const DEFAULT_AVATAR_PREFIX = "/assets/avatars/";

export const normalizeAvatarUrl = (avatar) => {
  if (!avatar) return "";
  const trimmed = avatar.trim();
  if (!trimmed) return "";

  if (/^(https?:)?\/\//.test(trimmed)) return trimmed;

  if (trimmed.startsWith("/assets/avatars/")) return trimmed;
  if (trimmed.startsWith("assets/avatars/")) return `/${trimmed}`;

  if (trimmed.startsWith("/")) return trimmed;

  return `${DEFAULT_AVATAR_PREFIX}${trimmed.replace(/^\/+/, "")}`;
};

export const deriveAvatarSelectorKey = (avatarUrl) => {
  if (!avatarUrl) return "";
  if (typeof window === "undefined") return avatarUrl;
  const origin = window.location.origin;
  return avatarUrl.startsWith(origin)
    ? avatarUrl.replace(origin, "")
    : avatarUrl;
};
